const getActiveCurrency = (currencies) => {
  const activeCurrency = currencies?.filter((items) => items.selected).pop();

  return activeCurrency?.id;
};

export default getActiveCurrency;
